import template from './add_edit_perf_manage_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class EditPerformanceManagementHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.selected_tab = ko.observable('cycle_setup');

		this.selected_tab.subscribe((newCategory) => {
			$('.help-tab > li').removeClass('active');
			$(`.help-tab > li[data-tabname=${newCategory}]`).addClass('active');
		});

		$(`.help-tab > li[data-tabname=${this.selected_tab()}]`).addClass('active');
	};

	switch_tabs(v, e)
	{
		let tabname = e.currentTarget.getAttribute('data-tabname');
		this.selected_tab(tabname);
	}

	close()
	{
		this.dialog.close();
	}
};

class EditPerformanceManagementHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EditPerformanceManagementHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EditPerformanceManagementHelp',
	dialog_class: EditPerformanceManagementHelpPage,
	template: template,
	template_filename: 'translation/dialogs/add_edit_perf_manage_help',
	provider: 'ps'
};
